import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-brookage',
    templateUrl: './dialog-brookage.component.html',
    styleUrls: ['./dialog-brookage.component.css']

})
export class DialogBrookageComponent implements OnInit {

    public modalDialog: any;
    public title: string;
    public text: string | string[];

    constructor(
        public dialog: MatDialog,
        private DialogRef: MatDialogRef<DialogBrookageComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any

    ) {
        this.modalDialog = data;
    }

    ngOnInit(

    ) {
        this.title = this.modalDialog.title;
        this.text = this.modalDialog.text;
    }

}
